import React from 'react';
import { FiExternalLink, FiCopy } from 'react-icons/fi';
import './CitationsComponent.scss';
import { copyToClipboard } from '../../utils/copyToClipboard';
import { AI_ASSISTANT_PENDO_EVENTS, trackAssistantEvent } from '../../utils/assistantAnalytics';

const CitationsComponent = ({ citations = [] }) => {
    return (
        <div className="citations-component">
            {citations.map((citation, index) => {
                const displayTitle = citation.title || citation.tile || '';
                const initial = displayTitle.charAt(0).toUpperCase() || '?';
                const hasLogo = citation.logo && String(citation.logo).trim().length > 0;
                const handleCopy = async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const ok = await copyToClipboard(citation.link || '');
                    if (ok) {
                        trackAssistantEvent(AI_ASSISTANT_PENDO_EVENTS.LINK_COPIED, {
                            linkType: "citation",
                        });
                    }
                };
                const handleOpen = () => {
                    trackAssistantEvent(AI_ASSISTANT_PENDO_EVENTS.LINK_OPENED, {
                        linkType: "citation",
                    });
                };
                return (
                <div key={index} className="citation-item">
                    <div className="citation-icon-container">
                        {hasLogo ? (
                            <img src={citation.logo} alt={displayTitle || "Source"} className="citation-icon" />
                        ) : (
                            <span className="citation-icon-fallback" aria-hidden>{initial}</span>
                        )}
                    </div>
                    <div className="citation-content">
                        <h4 className="citation-heading">{displayTitle}</h4>
                        {citation.date && <p className="citation-data">{citation.date}</p>}
                    </div>
                    <div className="citation-action">
                        <button
                            type="button"
                            className="citation-action__copy"
                            onClick={handleCopy}
                            aria-label="Copy link"
                        >
                            <FiCopy />
                        </button>
                        <a href={citation.link} target="_blank" rel="noopener noreferrer" aria-label="Open in new tab" onClick={handleOpen}>
                            <FiExternalLink />
                        </a>
                    </div>
                </div>
                );
            })}
        </div>
    );
};

export default CitationsComponent;
